export const TAX_STATUS_OPTIONS = [
  { label: "Director", value: "DIRST" },
  { label: "Statutory Tables", value: "ST" },
  { label: "Temp/Part Time", value: "TEMP" },
  { label: "Independent Contractor", value: "INDCON" },
] as const

export const NATURE_OF_CONTRACT_OPTIONS = [
  { label: "Permanent", value: "PERM" },
  { label: "Temporary", value: "TEMP" },
  { label: "Fixed Period", value: "FIXED" },
  { label: "Casual Worker", value: "CASUAL" },
] as const

export const TITLE_TYPE_OPTIONS = [
  { label: "MR", value: "MR" },
  { label: "MISS", value: "MISS" },
  { label: "MRS", value: "MRS" },
] as const

export const EMPLOYEE_STATUS_OPTIONS = [
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "INACTIVE" },
] as const

export const UIF_STATUS_OPTIONS = [
  { label: "Registered", value: "REGISTERED" },
  { label: "Exempt", value: "EXEMPT" },
] as const

// Type helpers for form schema validation
export type TaxStatusValue = (typeof TAX_STATUS_OPTIONS)[number]["value"]
export type NatureOfContractValue =
  (typeof NATURE_OF_CONTRACT_OPTIONS)[number]["value"]
export type TitleTypeValue = (typeof TITLE_TYPE_OPTIONS)[number]["value"]
export type EmployeeStatusValue =
  (typeof EMPLOYEE_STATUS_OPTIONS)[number]["value"]
export type UifStatusValue = (typeof UIF_STATUS_OPTIONS)[number]["value"]

// Code-to-label mapping functions
export function getTaxStatusLabel(code?: string): string {
  return TAX_STATUS_OPTIONS.find((opt) => opt.value === code)?.label ?? ""
}

export function getNatureOfContractLabel(code?: string): string {
  return (
    NATURE_OF_CONTRACT_OPTIONS.find((opt) => opt.value === code)?.label ?? ""
  )
}

export function getEmployeeStatusLabel(code?: string): string {
  return EMPLOYEE_STATUS_OPTIONS.find((opt) => opt.value === code)?.label ?? ""
}

export function getUifStatusLabel(code?: string): string {
  return UIF_STATUS_OPTIONS.find((opt) => opt.value === code)?.label ?? ""
}